let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gePdq")).then(() => parcelRequire('8usxn'));